import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import Spinner from '../components/ui/Spinner';
import { useAuth } from '../context/AuthContext';
import { parseApiError } from '../utils/apiError';

// Password reset landing. Reads the token from ?token= and posts to
// /api/auth/updatePassword. The token also comes back as devResetToken in
// non-prod (see ForgotPasswordModal).
export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError(null);
    setFieldErrors({});
    try {
      await resetPassword(token, password, password2);
      setDone(true);
      setSubmitting(false);
    } catch (err) {
      const { formError: fe, fieldErrors: fld } = parseApiError(err);
      setFormError(fe);
      setFieldErrors(fld);
      setSubmitting(false);
    }
  };

  return (
    <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-7)', maxWidth: 480 }}>
      <h1>Reset password</h1>
      <Card style={{ marginTop: 'var(--ss-space-4)' }}>
        {done ? (
          <div className="ss-form">
            <p className="ss-form__success">
              Your password has been reset. You can now log in with your new password.
            </p>
            <Link className="ss-btn ss-btn--primary" to="/">Back home</Link>
          </div>
        ) : !token ? (
          <div className="ss-form">
            <p className="ss-form__error">
              This reset link is missing its token. Request a new link from the log-in dialog.
            </p>
            <Link className="ss-btn ss-btn--ghost" to="/">Back home</Link>
          </div>
        ) : (
          <form className="ss-form" onSubmit={onSubmit} noValidate>
            {formError && <p className="ss-form__error" role="alert">{formError}</p>}
            {fieldErrors.token && <p className="ss-form__error" role="alert">{fieldErrors.token}</p>}
            <Input
              label="New password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={fieldErrors.password}
              required
            />
            <Input
              label="Confirm new password"
              type="password"
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              error={fieldErrors.password2}
              required
            />
            <div className="ss-form__actions">
              <Button type="submit" disabled={submitting}>
                {submitting ? <Spinner label="Saving" /> : 'Reset password'}
              </Button>
            </div>
          </form>
        )}
      </Card>
    </section>
  );
}
